import React from 'react';
import { Box } from '@mui/material';
import { useLocation, useParams } from 'react-router-dom';
import { APP_NAME } from '../../design-system/v2';
import './aurora-chrome.css';

interface HeaderProps {
  onMenuClick: () => void;
}

/**
 * Mobile Aurora nav bar — brand + menu. Account utilities live in the sidebar.
 */
export const Header: React.FC<HeaderProps> = ({ onMenuClick }) => {
  const location = useLocation();
  const { projectId = '' } = useParams();
  const overlayChrome =
    Boolean(projectId) && /\/projects\/[^/]+\//.test(location.pathname);

  return (
    <Box
      component="header"
      className="aurora-mobbar"
      sx={{
        position: overlayChrome ? 'absolute' : 'sticky',
        top: 0,
        left: 0,
        right: 0,
        zIndex: (t) => t.zIndex.appBar,
        flexShrink: 0,
        display: { xs: 'flex', lg: 'none' },
        bgcolor: 'transparent',
        pointerEvents: 'none',
        '& > *': { pointerEvents: 'auto' },
      }}
    >
      <button
        type="button"
        className="aurora-iconbtn"
        onClick={onMenuClick}
        aria-label="Open navigation menu"
        aria-expanded="false"
      >
        ☰
      </button>
      <span className="brand-sm">{APP_NAME}</span>
    </Box>
  );
};

export default Header;
